import { Grid } from "@mui/material";
import React from "react";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";

import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import UserOrderAndCreditDebitNoteTabs from "./components/userOrderAndCreditDebitNoteTabs";

function UserOrdersTable() {
  return (
    <div>
      <TitleHolder style={{ paddingBottom: "0" }}>
        <Grid container spacing={1}>
          <Grid sx={{ whiteSpace: "nowrap" }} item xs={6}>
            Orders & Credit/Debit Note
          </Grid>
          <Grid item xs={6}></Grid>
        </Grid>
      </TitleHolder>
      <br />
      <StepperContentHolder>
        <UserOrderAndCreditDebitNoteTabs />
      </StepperContentHolder>
    </div>
  );
}

export default UserOrdersTable;
